import { IGetPaymentsHistoryParams } from './types';

export const paymentsQueryKeys = {
  payments: () => ['payments'],
  paymentsList: (params: IGetPaymentsHistoryParams) => [...paymentsQueryKeys.payments(), params],
  paymentMethod: () => [...paymentsQueryKeys.payments(), 'paymentMethod'],
  paymentMethodUpdate: () => [...paymentsQueryKeys.paymentMethod(), 'update'],
};
